var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg28Filled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\xCD_\\xE3_1",
    "data-name": "\\xCD\\xBC\\xB2\\xE3_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 309.58 599.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#c8da2e;}.cls-2{stroke:#63676a;stroke-linecap:round;stroke-linejoin:round;stroke-width:6.5px;}.cls-3{font-size:80px;fill:#63676a;font-family:Arial-BoldMT, Arial;font-weight:700;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "83.63 139.96 111.5 84.22 195.12 129.51 218.34 215.45 155.63 209.64 99.89 191.06 83.63 139.96"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M186.54,130.31c-3.39-32.18-25.48-84.25-32.91-99.55-8.45-17.43-20.93-16.28-26-3.72-6.7,16.43-16.23,55.25-19,70.15"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.79,428.94c-25.95,0-93.44,34-132.43-8.48-31.24-34-19.7-115.93,2.69-171,8.33-20.5,8.64-40.12,6.52-62.14C21.43,82,42.47,10.11,78.26,8.14c26.88-1.47,27.27,180.05,78.3,169.24S181.9,3.25,217.81,3.25,283.06,77,278,187.29c-1,22.1-1.82,41.64,6.51,62.14,22.4,55.1,33.93,137,2.69,171C248.24,462.94,180.75,428.94,154.79,428.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.74,355.53c3.6,19.62,8.89,26.28,18.88,28C206,388.55,230,399.59,253,382.79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.51,406.07c-4.11-3.16-8-10.2-10.86-14.95-3.94-6.65-9-9-16.58-8.35-27.32,2.48-39.64,20.24-66.29,13.71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.16,240c-53.89-19.21-163.42-19.4-194.42,8"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(116.7 565.93)"
  }, "28")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg28Filled);
export default __webpack_public_path__ + "static/media/28_filled.fb0f988f.svg";
export { ForwardRef as ReactComponent };